import {
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { GradientBorderBox } from "../../../../../../Components";
import { spliter } from "../../../../../../Utils/Spliter";

export default function CartListMobileRow({
  title,
  price,
  qty,
  weight,
  prCode,
  vrCode,
  addPrToCart,
  removePrToCart,
  clearPrToCart,
  clearFullyCart,
  img,
  max,
}) {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        borderRadius: "8px",
        position: "relative",
        padding: "8px",
        gap: "1rem",
      }}
    >
      <Stack direction={"row"} sx={{ direction: "rtl" }}>
        {/* image */}
        <Box
          sx={{
            width: "70px",
            height: "70px",
            borderRadius: ".5rem",
            overflow: "hidden",
          }}
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src={
              img?.[0]?.file_name
                ? import.meta.env.VITE_URL + img?.[0]?.file_name
                : "/Media/nimobileIcon.png"
            }
            alt={import.meta.env.VITE_URL + img?.[0]?.alt}
          />
        </Box>
        {/* content */}
        <Stack sx={{ width: "80%", gap: "1rem" }}>
          {/* name and gram */}
          <Stack
            direction={"row"}
            sx={{
              gap: "1rem",
              alignItems: "center",
              justifyContent: "space-around",
              width: "100%",
            }}
          >
            <Typography sx={{}}>
              {spliter({ text: title, limit: 100, mobileLimit: 50 })}
            </Typography>
            <Typography sx={{ color: theme.palette.primary.main }}>
              {weight || "رنگ"}
            </Typography>
          </Stack>
          {/* prices */}
          <Stack
            direction={"row"}
            sx={{
              gap: "1rem",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <Typography sx={{}}>
              قیمت واحد : {price?.toLocaleString()}
            </Typography>
            <Typography sx={{ color: theme }}>
              کل : {(+price * +qty).toLocaleString() || "-"}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      {/* Buttons */}
      <Stack direction="row-reverse" gap="1rem" alignItems="center">
        {/* Quantity Controls */}
        <Stack direction="row-reverse" alignItems="center" gap="0.5rem">
          <IconButton
            sx={{
              bgcolor: theme.palette.primary.main,
              borderRadius: 1,
              color: "white",
              transition: "all .3s",
              "&:hover": {
                bgcolor: theme.palette.primary.main,
                color: theme.palette.background.default,
              },
              padding: "2px",
            }}
            disabled={max == qty ? true : false}
            onClick={() => addPrToCart(prCode, vrCode)}
          >
            <AddIcon sx={{ fontSize: "1.4rem" }} />
          </IconButton>

          <Typography sx={{ fontWeight: "bold" }}>{qty || 0}</Typography>

          <IconButton
            sx={{
              bgcolor: theme.palette.primary.main,
              borderRadius: 1,
              transition: "all .3s",
              "&:hover": {
                bgcolor: theme.palette.primary.main,
                color: theme.palette.background.default,
              },
              color: "white",
              padding: "2px",
            }}
            onClick={() => removePrToCart(prCode, vrCode)}
          >
            <RemoveIcon sx={{ fontSize: "1.4rem" }} />
          </IconButton>
        </Stack>

        {/* Remove Button */}
        <Button
          variant="outlined"
          sx={{ flex: 1, py: 0.5 }}
          onClick={() => clearPrToCart(prCode, vrCode)}
        >
          حذف از سبد خرید
        </Button>
      </Stack>

      {/* Grad */}
      <GradientBorderBox radius=".6rem" />
    </Stack>
  );
}
